import React, { useCallback } from 'react';

import type { RegisterMenuItem } from '@atlaskit/editor-ui-control-model/types';

import { getTypeAheadItemId } from './getTypeAheadItemId';
import type { TypeAheadItemComponent } from './typeAheadMenuTypes';

export const TypeAheadItemRow = ({
	isSelected,
	itemIndex,
	Item,
	listId,
	onItemHover,
	registration,
}: {
	isSelected: boolean;
	Item: TypeAheadItemComponent;
	itemIndex: number;
	listId: string;
	onItemHover: (itemIndex: number) => void;
	registration: RegisterMenuItem;
}): React.JSX.Element => {
	const onMouseMove = useCallback(() => onItemHover(itemIndex), [itemIndex, onItemHover]);

	return (
		<Item
			id={getTypeAheadItemId(listId, itemIndex)}
			isSelected={isSelected}
			onMouseMove={onMouseMove}
			registration={registration}
		/>
	);
};
